import React from 'react'
import { InputAdornment } from '@mui/material'
import { merge } from 'lodash'
import TextField, { TextFieldProps } from './TextField'

export type PercentFieldProps = TextFieldProps

const PercentField = ({ InputProps, ...rest }: PercentFieldProps) => {
	const endAdornment = (
		<InputAdornment position="end">%</InputAdornment>
	)
	const mergedInputProps = InputProps
		? merge(InputProps, { endAdornment })
		: { endAdornment }
	return <TextField InputProps={mergedInputProps} {...rest} />
}

export default PercentField
